import Vue from "vue";

const state = {
  clients: [],
  sub_admin: [],
  service_providers: [],
  allUsers: [],
  fileurl: "",
};

const getters = {
  clients: (state) => {
    return state.clients;
  },
  allUsers: (state) => {
    return state.allUsers;
  },
  active_clients: (state) => {
    return state.clients;
  },
  active_sub_admins: (state) => {
    return state.sub_admin.filter((item) => item.status == "active");
  },

  service_providers: (state) => {
    return state.service_providers.filter((item) => item.isverified == true);
  },
  active_service_providers: (state) => {
    return state.service_providers.filter(
      (item) =>
        item.status == "active" &&
        item.isverified == false &&
        item.submission == true
    );
  },
};

const actions = {
  fetchAllGeneralUsers({ commit }) {
    firebase
      .database()
      .ref("users")
      .on("value", (snapshot) => {
        commit("setAllGenUsers", snapshot.val());
      });
  },
  fetchAllUsers({ commit }) {
    firebase
      .database()
      .ref("users")
      .orderByChild("type")
      .equalTo("user")
      .on("value", (snapshot) => {
        commit("setAllUsers", snapshot.val());
      });
  },
  fetchAllSubAdmins({ commit }) {
    firebase
      .database()
      .ref("users")
      .orderByChild("type")
      .equalTo("sub_admin")
      .on("value", (snapshot) => {
        commit("setAllSubAdmins", snapshot.val());
      });
  },
  fetchAllServiceProviders({ commit }) {
    firebase
      .database()
      .ref("users")
      .orderByChild("type")
      .equalTo("provider")
      .on("value", (snapshot) => {
        commit("setAllProviders", snapshot.val());
      });
  },
  createUser({ state, commit }, user) {
    const { confirm_password, password, file, ...exclude } = user;
    const payload = Object.assign({}, { ...exclude });

    if (user.type == "provider") {
      const database = firebase.database();
      const imgRef = database.ref("users");
      var filename = user.file.name;

      let customkey = imgRef.push().getKey();
      let ext = filename.slice(filename.lastIndexOf("."));

      if (user.insurancefile != "") {
        var insurancefilename = user.insurancefile.name;
        let ext2 = insurancefilename.slice(insurancefilename.lastIndexOf("."));
        var filename = user.file.name;

        firebase
          .storage()
          .ref("InsuranceStorage/" + customkey + ext2.toLowerCase())
          .put(user.insurancefile)
          .then((filedata) => {
            filedata.ref.getDownloadURL().then((URL) => {
              console.log("odi");
              commit("setfileUrl", URL);
              firebase
                .storage()
                .ref("Users/" + customkey + ext.toLowerCase())
                .put(user.file)
                .then((filedata) => {
                  filedata.ref.getDownloadURL().then((URL) => {
                    console.log(URL);
                    // localStorage.setItem("imageurl", URL);

                    firebase
                      .auth()
                      .createUserWithEmailAndPassword(user.email, user.password)
                      .then((result) => {
                        firebase
                          .database()
                          .ref("users")
                          .child(result.user.uid)
                          .set({
                            ...payload,
                            profile_image: URL,
                            insurance_file: state.fileurl,
                          })
                          .then((save) => {
                            // commit('setError', "no")
                            commit("setNotifications", {
                              message: "New user created successfully",
                              type: "success",
                            });
                          })
                          .catch((err) => {
                            commit("setNotifications", {
                              message: err.message,
                              type: "error",
                            });
                          });
                      })
                      .catch((err) => {
                        commit("setNotifications", {
                          message: err.message,
                          type: "error",
                        });
                      });
                  });
                })
                .catch((error) => console.log(error.message));
            });
          });
      } else {
        firebase
          .storage()
          .ref("Users/" + customkey + ext.toLowerCase())
          .put(user.file)
          .then((filedata) => {
            filedata.ref.getDownloadURL().then((URL) => {
              console.log(URL);
              // localStorage.setItem("imageurl", URL);

              firebase
                .auth()
                .createUserWithEmailAndPassword(user.email, user.password)
                .then((result) => {
                  firebase
                    .database()
                    .ref("users")
                    .child(result.user.uid)
                    .set({
                      ...payload,
                      profile_image: URL,
                      insurance_file: state.fileurl,
                    })
                    .then((save) => {
                      // commit('setError', "no")
                      commit("setNotifications", {
                        message: "New user created successfully",
                        type: "success",
                      });
                    })
                    .catch((err) => {
                      commit("setNotifications", {
                        message: err.message,
                        type: "error",
                      });
                    });
                })
                .catch((err) => {
                  commit("setNotifications", {
                    message: err.message,
                    type: "error",
                  });
                });
            });
          })
          .catch((error) => console.log(error.message));
      }
    } else {
      firebase
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password)
        .then((result) => {
          firebase
            .database()
            .ref("users")
            .child(result.user.uid)
            .set(payload)
            .then((save) => {
              // commit('setError', "no")
              commit("setNotifications", {
                message: "New user created successfully",
                type: "success",
              });
            })
            .catch((err) => {
              commit("setNotifications", {
                message: err.message,
                type: "error",
              });
            });
        })
        .catch((err) => {
          commit("setNotifications", { message: err.message, type: "error" });
        });
    }
  },
};
const mutations = {
  setAllUsers: (state, payload) => {
    let users_Array = [];
    for (let key in payload) {
      payload[key].id = key;
      users_Array.push(payload[key]);
    }
    state.clients = users_Array;
  },
  setAllSubAdmins: (state, payload) => {
    console.log(payload);
    let users_Array = [];
    for (let key in payload) {
      payload[key].id = key;
      users_Array.push(payload[key]);
    }
    state.sub_admin = users_Array;
  },
  setAllProviders(state, payload) {
    let users_Array = [];
    for (let key in payload) {
      payload[key].id = key;
      users_Array.push(payload[key]);
    }
    state.service_providers = users_Array;
  },
  setAllGenUsers(state, payload) {
    let users_Array = [];
    for (let key in payload) {
      payload[key].id = key;
      users_Array.push(payload[key]);
    }
    state.allUsers = users_Array;
  },
  setfileUrl(state, payload) {
    state.fileurl = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
